<script lang="ts" setup>
import type { Placement } from '../../ideo/ui-popover/types';

defineOptions({
    name: 'Confirmation'
});

const props = withDefaults(defineProps<{
    value: any;
    target: any;
    message: string;
    placement?: Placement;
    id?: string | null;
    wrapperClass?: Record<string, boolean> | string[] | string;
    actionClass?: Record<string, boolean> | string[] | string;
}>(), {
    placement: 'left',
    wrapperClass: '',
    actionClass: '',
    id: null
});

const emit = defineEmits<{
    (e: 'confirm', value: any): void;
    (e: 'cancel'): void;
}>();

const popover = ref(null);

const open = (target?: HTMLElement): void =>
{
    popover.value.open(target);
};

const close = (): void =>
{
    popover.value.close();
};

const confirm = (): void =>
{
    close();
    emit('confirm', props.value);
};

const cancel = (): void =>
{
    close();
};

const wrapperClasses = computed(() => ({
    'd-flex align-items-center': true,
    ...normalizeClasses(props.wrapperClass)
}));

const actionClasses = computed(() => ({
    'ms-auto': true,
    ...normalizeClasses(props.actionClass)
}));

defineExpose({
    open
});
</script>

<template>
    <IdeoPopover
        :id="id"
        ref="popover"
        class="popover"
        :target="target"
        :placement="placement"
        triggers="blur click"
    >
        <div :class="wrapperClasses">
            <b class="me-2" v-html="message.replaceAll('\n', '<br>')" />
            <div :class="actionClasses">
                <IdeoButtonGroup class="rounded overflow-hidden" size="sm">
                    <IdeoButton variant="danger" @mousedown.stop.prevent="confirm">
                        {{ $t('[[[Tak]]]') }}
                    </IdeoButton>
                    <IdeoButton variant="secondary" @mousedown.stop.prevent="cancel">
                        {{ $t('[[[Nie]]]') }}
                    </IdeoButton>
                </IdeoButtonGroup>
            </div>
        </div>
    </IdeoPopover>
</template>

<style lang="scss" scoped>
.popover {
    border-radius: 4px;
    min-width: 250px;
}
</style>
